<ng-template #template>
    <div class="modal-header">
        <h4 class="modal-title">{{ 'buyer.dados-pedido.modal.adicionar-complemento.titulo' | translate}} - {{ cotacaoSelecionada?.veiculo }}</h4>
        <button type="button" data-dismiss="modal" aria-label="Close" class="btn-close" (click)="fecharModal(false);"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-4 col-md-4">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.codigo.label' | translate}}</label>
                    <input id="part_number" name="part_number" [(ngModel)]="peca.codigo" maxlength="20" type="text" class="form-control text-uppercase restrict-special-characters" />
                </div>
            </div>
            <div class="col-sm-8 col-md-8">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.descricao.label' | translate}}</label>
                    <input id="descricao" name="descricao" [(ngModel)]="peca.descricao" maxlength="200" type="text" class="form-control text-capitalize restrict-special-characters" />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-1 col-md-1">
                <div class="mb-1 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.quantidade.label' | translate}}</label>
                    <input type="number" class="form-control form-control-sm quantity" [(ngModel)]="peca.quantidade" maxlength="3" min="1" max="999" (input)="onInputQuantityChange($event, peca)" />
                </div>
            </div>
            <div class="col-sm-3 col-md-3">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.valor-unitario.label' | translate}}</label>
                    <div class="input-group">
                        <span class="input-group-text">R$</span>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="peca.valor_unitario" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" min="0" max="99999.99" maxlength="7" />
                    </div>
                </div>
            </div>
            <div class="col-sm-2 col-md-2">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.desconto.label' | translate}}</label>
                    <div class="input-group">
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="peca.desconto" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" min="0" max="99" maxlength="4" />
                        <span class="input-group-text"><i class="fa fa-percent" aria-hidden="true"></i></span>
                    </div>
                </div>
            </div>
            <div class="col-sm-3 col-md-3">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.valor-total.label' | translate}}</label>
                    <div class="input-group">
                        <span class="input-group-text">
                            <span>R$</span>
                        </span>
                        <input type="text" class="form-control form-control-sm" [(ngModel)]="valor_total" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" readonly />
                    </div>
                </div>
            </div>

            <div class="col-sm-3 col-md-3">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.prazo.label' | translate}}</label>
                    <div class="input-group">
                        <input class="form-control form-control-sm" placeholder="dd/mm/yyyy" name="dp" [(ngModel)]="peca.data_entrega" ngbDatepicker #d="ngbDatepicker" [firstDayOfWeek]="7" [minDate]="calendarMinDate" [maxDate]="calendarMaxDate" [markDisabled]="calendarMarkDisabled">
                        <div class="input-group-text cursor-pointer" (click)="d.toggle()"><i class="fa fa-calendar" aria-hidden="true"></i></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-md-4">
                <div class="mb-3 form-group">
                    <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.tipo-peca.label' | translate}}</label>
                    <select class="form-select form-select-sm"[(ngModel)]="peca.part_type" >
                        <option value="1" selected>{{ 'elemento.tipo-pecas.genuina' | translate}}</option>
                        <option value="2">{{ 'elemento.tipo-pecas.original' | translate}}</option>
                        <option value="4">{{ 'elemento.tipo-pecas.alternativa' | translate}}</option>
                        <option value="8">{{ 'elemento.tipo-pecas.importada' | translate}}</option>
                    </select>
                </div>
            </div>
            @if (peca.part_type > 1) {
                <div class="col-sm-4 col-md-4">
                    <div class="mb-3 form-group">
                        <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.marca-peca.label' | translate}}</label>
                        <input id="brand" name="brand" [(ngModel)]="peca.brand" maxlength="50" type="text" class="form-control text-capitalize restrict-special-characters" />
                    </div>
                </div>
            }
            <div class="col-sm-4 col-md-4">
                <label>{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.condicao.label' | translate}}</label>
                <select class="form-select form-select-sm" [(ngModel)]="peca.allows_used" >
                    <option [ngValue]="false">{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.condicao.nova' | translate}}</option>
                    <option [ngValue]="true">{{ 'buyer.dados-pedido.modal.adicionar-complemento.peca.condicao.usada' | translate}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="adicionar" type="submit" class="btn btn-primary" (click)="adicionar(0);" [disabled]="!alreadyLoadedERP ? 'disabled' : null">{{ 'elemento.generico-botao.adicionar' | translate}}</button>
        <button id="closeModal" type="button" class="btn btn-light" (click)="fecharModal(false);">{{ 'elemento.generico-botao.fechar' | translate}}</button>
    </div>
    <ngx-loading [show]="loading" [template]="templateAdicionarComplemento"></ngx-loading>
</ng-template>
<ng-template #templateAdicionarComplemento></ng-template>
